import {createContext, useContext, useEffect, useState, useRef} from 'react';
import axios from 'axios'
import {EnvContext} from './EnvContext';
import { UserContext } from './UserContext';
import {io} from 'socket.io-client';
import { Mutex } from 'async-mutex';

export const LeadsContext = createContext();

export const LeadsContextProvider = ({children}) => {
    const  {baseURL}  = useContext(EnvContext);
    const {user} = useContext(UserContext);

    const Axios = axios.create({ baseURL: baseURL });

    const [leadsLoading, setLeadsLoading] = useState(false);

    const [singlePagination, setsinglePagination] = useState(true);
    const [activeLeadID, setActiveLeadID] = useState(null);
    const [leadSearch,setLeadSearch] = useState(0);
    const [activeLeadAction,setActiveLeadAction] = useState(null);
    const [leadData, setLeadData] = useState([]);
    const [archivedLeadData, setArchivedLeadData] = useState([]);
    const [ activeTab, setActiveTab]  = useState(true);

    const [leadFields,setLeadFields] = useState([]);

    const [allLeads,setAllLeads] = useState([]);

    const [emailScripts,setEmailScripts] = useState([]);

    const [textScripts,setTextScripts] = useState([]);

    const [agentData,setAgentData] = useState([]);

    const [leaderboard,setLeaderboard] = useState([]);    

    const [notifications,setNotifications] = useState([]);    

    /*
        search stuff
        https://medium.com/@kishorkrishna/cant-access-latest-state-inside-socket-io-listener-heres-how-to-fix-it-1522a5abebdb
        socket state issue inside on message fix
    */

    const [searchText,setSearchText] = useState("");
    const searchRef = useRef(searchText);
    const [searchExists,setSearchExists] = useState(false);
    const [leadsFetching,setLeadsFetching] = useState(false);

    const [filteredLeads, setFilteredLeads] = useState([]);
    const [filteredSMLeads,setFilteredSMLeads] = useState([]);
    const [filteredArchivedLeadData, setFilteredArchivedLeadData] = useState([]);    

    const [queryLeadID,setQueryLeadID] = useState(null);

    const leadsFetchMutex = useRef(new Mutex());

    const [isInitialLoad,setIsInitialLoad] = useState(true);

    const [defaultYears, setDefaultYears] = useState([]);

    const getLeadIDParam = () => {
        const queryParameters = new URLSearchParams(window.location.search)
        const query_lead_id = queryParameters.get("lead_id");

        setQueryLeadID(query_lead_id);

        return query_lead_id;
    }

    const [selectedId, setSelectedId] = useState(null);

    const selectLead = (id,params="") => {

        setLeadSearch((prev) => prev + 1);
        setActiveLeadID(id);

        var activePage = window.location.pathname.includes('/store') ? "/store" : "/web";

        if(leadData.some((lead) => lead.id == id) || (activePage == "/web" && archivedLeadData.some((lead) => lead.id == id))) { // || (window.location.pathname.includes('/store') && allLeads.some((lead) => lead.id == id))
            console.log("selecting lead",id,leadData.filter((lead) => lead.id == id));
        } else if(allLeads.some((lead) => lead.id == id) && !queryLeadID && !id.toString().includes('SM_')) {
            window.open(activePage + "?lead_id=" + id + (params != "" ? "&" + params : ""), '_blank')
        }
    }


    useEffect(() => {

        searchRef.current = searchText;

        var filteredResults = filterLeadData(leadData);
        
        if(filteredResults.length==0){
            //filteredResults = leadData;
            setsinglePagination(true);
        }
        else{
            setsinglePagination(false);
        }

        setFilteredLeads(filteredResults);

        setFilteredSMLeads(filterLeadData(allLeads.filter((lead) => lead.appraisal > 0 && lead.id.includes('SM_'))));

        setFilteredArchivedLeadData(filterLeadData(archivedLeadData));
    }, [searchText, leadData]);

    /*search stuff*/

    const filterLeadData = (leadData) => {
        var filteredResults;

        var query_lead_id = getLeadIDParam();

        if(!searchText && query_lead_id) {
            filteredResults = leadData.filter(lead =>
                (lead.id && lead.id == query_lead_id)
            );
        } else if (!searchText) {
            filteredResults = leadData;
        } else {
            filteredResults = leadData.filter(lead =>
                (lead.year && (lead.year + '').includes(searchText)) ||
                (lead.make && lead.make.toLowerCase().includes(searchText.toLowerCase())) ||
                (lead.vehicle_name && lead.vehicle_name.toLowerCase().includes(searchText.toLowerCase())) ||
                (lead.vin && lead.vin.toLowerCase().includes(searchText.toLowerCase())) ||
                (lead.phone && lead.phone.replace(/[^a-zA-Z0-9]/g, '').toLowerCase().includes(searchText.replace(/[^a-zA-Z0-9]/g, '').toLowerCase())) ||
                (lead.email && lead.email.toLowerCase().includes(searchText.toLowerCase())) ||
                (lead.first_name && lead.last_name && (lead.first_name.toLowerCase() + " " + lead.last_name.toLowerCase()).includes(searchText.toLowerCase())) ||
                (lead.id && (lead.id + "").toLowerCase().includes(searchText.toLowerCase()))
            );
        }

        return filteredResults;
    }


    const getLeads = async (no_search=false,initial_load=false,backend_search=false) => {

        var query_lead_id = getLeadIDParam();

        var today = new Date();

        var tzoffset = today.getTimezoneOffset() * 60000;
        var yesterday = new Date(Date.parse(today) - tzoffset);

        console.log("getting mutex");
        const release = await leadsFetchMutex.current.acquire();
        console.log("got mutex",release);
        setLeadsLoading(true);
        try {
            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const values = {'agent_id':user.user_id,'admin':user.admin,'search_text':backend_search && searchRef.current != "" ? searchRef.current : "",'tzoffset':tzoffset};

            if(query_lead_id && !searchRef.current && !no_search && !backend_search) values.lead_id = query_lead_id;

            if(isInitialLoad || initial_load) values.initial_load = true;

            console.log("getting leads",searchRef.current,isInitialLoad,initial_load,query_lead_id,no_search,backend_search,values);

            setSearchExists(backend_search && searchRef.current != "");

            console.log(searchRef.current,window.location.pathname.includes('/store'),!searchRef.current,!query_lead_id)

            if(window.location.pathname.includes('/store') && ((!backend_search && !query_lead_id) || no_search)) values.lead_type = 'InPerson';
            if(window.location.pathname.includes('/web') && ((!backend_search && !query_lead_id) || no_search)) values.lead_type = 'Web';

            setLeadsFetching(true);

            const response = await Axios.post('bridge/leads/leads.php',values);
            console.log(response.data);
            setLeadsLoading(false);

            var leads = [];
            var archived_leads = [];

            yesterday.setDate(yesterday.getDate() - 1);
            yesterday.setHours(0, 0, 0, 0);
            response.data.map((v,i) => {
                var name_parts = [];
                if(!v.vehicle_name)  {
                    if(v.year) name_parts.push(v.year);
                    if(v.make) name_parts.push(v.make);
                    if(v.model) name_parts.push(v.model);
                    if(v.trim) name_parts.push(v.trim);

                    v.vehicle_name = name_parts.length > 0 ? name_parts.join(' ') : v.vin;
                }                
                
                if((v.next_callback_date || v.callback_date) && (v.appraisal_stage == "Callback" || v.appraisal_stage == "Completed"))
                    v.callback_date_obj = v.next_callback_date ? new Date(Date.parse(v.next_callback_date) + tzoffset) : (v.callback_date ? new Date(Date.parse(v.callback_date) + tzoffset) : new Date(v.created_at));
                else 
                    v.callback_date_obj = null;

                v.callback_date_orig_obj = v.callback_date ? new Date(Date.parse(v.callback_date) + tzoffset) : new Date(v.created_at);

                v.created_at_obj = v.created_at ? new Date(Date.parse(v.created_at) - tzoffset) : new Date();

                v.created_at_str = String(v.created_at_obj.getMonth() + 1).padStart(2, '0') + "/" + String(v.created_at_obj.getDate()).padStart(2, '0') + "/" + String(v.created_at_obj.getFullYear()).substr(-2);

                v.task_start_date_obj = v.task_start_date ? new Date(Date.parse(v.task_start_date) - tzoffset) : v.created_at_obj;

                v.task_start_diff = today.getTime() - v.task_start_date_obj.getTime();

                v.appraisal_date_obj = v.appraisal_date ? new Date(Date.parse(v.appraisal_date) + tzoffset) : v.task_start_date_obj;

                v.appraisal_date_str = String(v.appraisal_date_obj.getMonth() + 1).padStart(2, '0') + "/" + String(v.appraisal_date_obj.getDate()).padStart(2, '0') + "/" + String(v.appraisal_date_obj.getFullYear()).substr(-2);

                v.expiration_obj = v.expiration_date ? new Date(Date.parse(v.expiration_date) + tzoffset) : new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);

                v.days_to_expire = Math.ceil((v.expiration_obj - today) / (1000 * 60 * 60 * 24));

                v.expiration_str = String(v.expiration_obj.getMonth() + 1).padStart(2, '0') + "/" + String(v.expiration_obj.getDate()).padStart(2, '0') + "/" + String(v.expiration_obj.getFullYear()).substr(-2);

                v.appointment_date_obj = v.appointment_date ? new Date(Date.parse(v.appointment_date) - tzoffset) : new Date();

                v.appointment_str = String(v.appointment_date_obj.getMonth() + 1).padStart(2, '0') + "/" + String(v.appointment_date_obj.getDate()).padStart(2, '0') + "/" + String(v.appointment_date_obj.getFullYear()).substr(-2);

                //if(v.appointment_date) {
                //    console.log(v.id,yesterday,v.appointment_date,v.appointment_date_obj);
                //}

                v.appointment_passed = (v.appointment_date && v.appointment_date_obj <= yesterday);

                if(v.archived) archived_leads.push(v);
                else leads.push(v);
            })
            setLeadData(leads);
            setFilteredLeads(leads);
            setArchivedLeadData(archived_leads);

            if(query_lead_id && !searchRef.current) selectLead(query_lead_id);
        } catch (error) {
            // console.error('Error fetching leads:', error);
            setLeadsLoading(false);
            return {}; // Or handle error as needed
        } finally {
            console.log("releasing mutex");
            release(); // Always release the mutex
        }
    };

    const getLeadData = async (lead_id) => {
        try {
            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const values = {'lead_id':lead_id};

            console.log(values);

            const response = await Axios.post('bridge/leads/lead_data.php',values);

            return response.data && response.data.success ? response.data.data : {};
        } catch (error) {
            // console.error('Error fetching leads:', error);
            return {}; // Or handle error as needed
        }
    }

    const migrateWebLead = async (values) => {
        try {

            if(user && user.first_name && user.last_name) values.user_full_name = user.first_name + " " + user.last_name;
            
            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            //const values = {'lead_id':lead_id};

            console.log(values);

            const response = await Axios.post('bridge/leads/migrate_web_lead.php',values);

            const success = response.data && response.data.success;

            if(success) {
                const lead_response = await getLeads();
                sendUpdateMessage("migrateWebLead");
            }

            return response.data;
        } catch (error) {
            // console.error('Error fetching leads:', error);
            return {}; // Or handle error as needed
        }
    }

    const copySniperMonkeyLead = async (lead_id) => {
        try {
            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const values = {'lead_id':lead_id};

            console.log(values);

            const response = await Axios.post('bridge/leads/copy_snipermonkey_appraisal.php',values);

            return response.data ? response.data : {};
        } catch (error) {
            // console.error('Error fetching leads:', error);
            return {}; // Or handle error as needed
        }
    }

    const getLeadFields = async () => {
        try {
            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/lead_fields.php');

            // console.log(response.data);
            setLeadFields(response.data);


        } catch (error) {
            console.error('Error fetching lead fields:', error);
            return {}; //Or handle error as needed
        }
    };

    const getAllLeads = async () => {
        try {
            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/all_leads.php');

            var leads = [];

            var today = new Date();

            var tzoffset = today.getTimezoneOffset() * 60000;

            response.data.map((v,i) => {
                var name_parts = [];
                if(!v.vehicle_name)  {
                    if(v.year) name_parts.push(v.year);
                    if(v.make) name_parts.push(v.make);
                    if(v.model) name_parts.push(v.model);
                    if(v.trim) name_parts.push(v.trim);

                    v.vehicle_name = name_parts.length > 0 ? name_parts.join(' ') : v.vin;
                }

                v.lead_id = v.id.toUpperCase();

                v.created_at_obj = v.created_at ? new Date(Date.parse(v.created_at) - tzoffset) : new Date();

                v.created_at_str = String(v.created_at_obj.getMonth() + 1).padStart(2, '0') + "/" + String(v.created_at_obj.getDate()).padStart(2, '0') + "/" + String(v.created_at_obj.getFullYear()).substr(-2);

                v.appraisal_date_obj = v.appraisal_date ? new Date(Date.parse(v.appraisal_date) - tzoffset) : v.created_at_obj;

                v.appraisal_date_str = String(v.appraisal_date_obj.getMonth() + 1).padStart(2, '0') + "/" + String(v.appraisal_date_obj.getDate()).padStart(2, '0') + "/" + String(v.appraisal_date_obj.getFullYear()).substr(-2);
                
                v.expiration_obj = v.expiration_date ? new Date(Date.parse(v.expiration_date) - tzoffset) : new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);

                v.expiration_str = String(v.expiration_obj.getMonth() + 1).padStart(2, '0') + "/" + String(v.expiration_obj.getDate()).padStart(2, '0') + "/" + String(v.expiration_obj.getFullYear()).substr(-2);

                v.days_to_expire = Math.ceil((v.expiration_obj - today) / (1000 * 60 * 60 * 24));

                v.partial_lead_data = true;

                leads.push(v);
            });

            // console.log(response.data);
            setAllLeads(leads);
            setFilteredSMLeads(leads.filter((lead) => lead.appraisal > 0 && lead.id.includes('SM_')));


        } catch (error) {
            console.error('Error fetching lead fields:', error);
            return {}; //Or handle error as needed
        }
    };

    const getEmailScripts = async () => {
        try {
            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/email_scripts.php');

            // console.log(response.data);
            setEmailScripts(response.data);


        } catch (error) {
            console.error('Error fetching email scripts:', error);
            return {}; //Or handle error as needed
        }
    };

    const getEmailScriptsHtml = async () => {
        try {
            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/email_scripts_html.php');

            return response.data ? response.data : [];


        } catch (error) {
            console.error('Error fetching email scripts:', error);
            return {}; //Or handle error as needed
        }
    };

    const getTextScripts = async () => {
        try {
            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/text_scripts.php');

            // console.log(response.data);
            setTextScripts(response.data);


        } catch (error) {
            console.error('Error fetching text scripts:', error);
            return {}; //Or handle error as needed
        }
    };

    const getAgents = async () => {
        try {
            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/agents.php');

            // console.log(response.data);
            setAgentData(response.data);


        } catch (error) {
            console.error('Error getting agent:', error);
            return {}; //Or handle error as needed
        }
    };

    const getLeaderboard = async () => {
        try {
            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/leaderboard.php');

            // console.log(response.data);
            setLeaderboard(response.data);


        } catch (error) {
            console.error('Error getting leaderboard:', error);
            return {}; //Or handle error as needed
        }
    };

    const getNotifications = async () => {
        try {
            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const values = {'agent_id':user.user_id,'admin':user.admin};

            console.log(values);

            const response = await Axios.post('bridge/leads/notifications.php',values);

            console.log(response);

            // console.log(response.data);
            setNotifications(response.data.success ? response.data.data : []);


        } catch (error) {
            console.error('Error getting leaderboard:', error);
            return {}; //Or handle error as needed
        }
    };

    const assignAgent = async (agent_id,id) => {
        try {
            const values = {'agent_id':agent_id,'lead_id':id};
            // console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/assign_agent.php',values);

            // console.log(response.data);

        } catch (error) {
            console.error('Error assigning agent:', error);
            return {}; //Or handle error as needed
        }
    };

    const updateTask = async (lead_id,schedule_id,task_text,completed,task_date="",refresh=false) => {
        try {

            //if(task_date == "") {
            //    const now = new Date();
            //    task_date = (now.getMonth() + 1) + "/" + now.getDate();
            //}
            const values = {'lead_id':lead_id,'schedule_id':schedule_id,'task_text':task_text,'completed':completed,'task_date':task_date};
            // console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/update_task.php',values);

            if(response.data.success && refresh) getLeads(false,searchRef.current == "");

            // console.log(response.data);

        } catch (error) {
            console.error('Error updating task:', error);
            return {}; //Or handle error as needed
        }
    };

    const completeNextTask = async (email,vin,type) => {
        try {
            const values = {'email':email,'vin':vin,'type':type};
            // console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/complete_next_task.php',values);

            // console.log(response.data);

            return response.data && response.data.success && response.data.task_id ? response.data.task_id : false;

        } catch (error) {
            console.error('Error completing next task:', error);
            return {}; //Or handle error as needed
        }
    };

    const archiveLead = async (thisLead,no_refresh=false,unArchive=false) => {
        try {
            const response = await updateLeadData(thisLead.id,'archived',!unArchive);

            if(response.data.success && !no_refresh) getLeads(false,searchRef.current == "");

        } catch (error) {
            console.error('Error archiving lead:', error);
            return {}; //Or handle error as needed
        }
    };

    const  updateLeadData = async (id,field,value) => {
        try {
            const values = {'id':id,'field':field,'value':value};
            // console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/update_lead_data.php',values);

            console.log(response.data);

            if(response.data.success) {
                const lead_response = getLeads(false,searchRef.current == "");
                sendUpdateMessage("updateLeadData");
            }

            return response.data;

        } catch (error) {
            console.error('Error updating lead data:', error);
            return {}; //Or handle error as needed
        }
    };

    const  updateLeadDataMultiple = async (values) => {
        try {
            console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/update_lead_data_multiple.php',values);

            console.log(response.data);

            if(response.data.success) {
                const lead_response = getLeads(false,searchRef.current == "");
                sendUpdateMessage("updateLeadDataMultiple");
            }

            return response.data;

        } catch (error) {
            console.error('Error updating lead data:', error);
            return {}; //Or handle error as needed
        }
    };

    const addEmailScript = async (values) => {
        try {
            //const values = {'script_name':script_name,'subject':subject,'script':script,'type':type,'do_update':do_update};
            // console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/add_email_script.php',values);

            // console.log(response.data);

            if(response.data.success && values.type == 'email') getEmailScripts();
            if(response.data.success && values.type == 'text') getTextScripts();

            return response.data;

        } catch (error) {
            console.error('Error adding email script:', error);
            return {}; //Or handle error as needed
        }
    }

    const deleteEmailScript = async (script_id, type) => {
        try {
            const values = {'script_id':script_id,'type':type};
            // console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/delete_script.php',values);

            // console.log(response.data);

            if(response.data.success && type == 'email') getEmailScripts();
            if(response.data.success && type == 'text') getTextScripts();

            return response.data;

        } catch (error) {
            console.error('Error adding email script:', error);
            return {}; //Or handle error as needed
        }
    }

    const addNoteWrapper = async (leadData,title,subtitle,note) => {
        const values = {'id':leadData.id,'title':title,'subtitle':subtitle,'note':note};
        const response = await addNote(values);

        if (response && response.success && response.note) leadData.notes.unshift(response.note);
    }

    const addNote = async (values) => {
        try {
            
            // console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/add_note.php',values);

            // console.log(response.data);

            //sendUpdateMessage("addNote");

            return response.data;

        } catch (error) {
            console.error('Error adding note:', error);
            return {}; //Or handle error as needed
        }
    };

    const deleteNote = async (id) => {
        try {
            
            var values = {"id":id};

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/delete_note.php',values);

            // console.log(response.data);

            return response.data;

        } catch (error) {
            console.error('Error adding note:', error);
            return {}; //Or handle error as needed
        }
    };

    const updateNote = async (values) => {
        try {

            console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/update_note.php',values);

            // console.log(response.data);

            return response.data;

        } catch (error) {
            console.error('Error adding note:', error);
            return {}; //Or handle error as needed
        }
    };


    const addLead = async (values) => {
        try {

            if(user && user.first_name && user.last_name) values.user_full_name = user.first_name + " " + user.last_name;

            if(!('lead_type' in values)) values.lead_type = 'InPerson';
            
            // console.log(values);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/add_lead.php',values);

            // console.log(response.data);

            if(response.data.success) {
                const lead_response = await getLeads();
                sendUpdateMessage("addLead");
            }

            return response.data;

        } catch (error) {
            console.error('Error adding lead:', error);
            return {}; //Or handle error as needed
        }
    };

    const sendSms = async (formValues,leadData) => {
        try {
            // console.log(formValues);

            const today = new Date();
            today.setHours(23);
            today.setMinutes(59);

            const has_task = leadData.tasks.find((task,i) => {
                const task_date = new Date(task.date);
                task_date.setFullYear(today.getFullYear());
                return task_date < today && !task.completed;
            });

            if(has_task) {
                console.log("completing task",has_task);
                updateTask(leadData.id,has_task.id,has_task.text,true,has_task.date,true);
            }

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/twilio/send_sms.php',formValues);

            addNoteWrapper(leadData,"Sent SMS","",formValues.message);

            getLeads(false,searchRef.current == "");

            return response.data;


        } catch (error) {
            console.error('Error sending text:', error);
            return {}; //Or handle error as needed
        }
    };

    const sendPlainTextEmail = async (formValues,leadData,sendingAgent={}) => {
        try {
            // console.log(formValues);

            const today = new Date();
            today.setHours(23);
            today.setMinutes(59);

            const has_task = leadData.tasks.find((task,i) => {
                const task_date = new Date(task.date);
                task_date.setFullYear(today.getFullYear());
                return task_date < today && !task.completed;
            });

            if(has_task) {
                console.log("completing task",has_task);
                updateTask(leadData.id,has_task.id,has_task.text,true,has_task.date,true);
            }

            formValues.agent_name = "full_name" in sendingAgent ? sendingAgent["full_name"] : leadData.agent_name;
            formValues.vin = leadData.vin;

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/email/send_plaintext.php',formValues);

            addNoteWrapper(leadData,"Sent Email","first_name" in sendingAgent ? " - from " + sendingAgent["first_name"] : "",formValues.message);

            getLeads(false,searchRef.current == "");

            return response.data;

        } catch (error) {
            console.error('Error sending text:', error);
            return {}; //Or handle error as needed
        }
    };

    const decodeVIN = async (vin) => {
        try {
            const values = {'vin':vin};
            console.log("decoding vin",vin);

            const loginToken = localStorage.getItem('loginToken');
            Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

            const response = await Axios.post('bridge/leads/decode_vin.php',values);

            console.log(response.data);

            return response.data.success ? response.data.data : {};

        } catch (error) {
            console.error('Error adding email script:', error);
            return {}; //Or handle error as needed
        }
    };
    
    const uploadDocument = async (values) => {

        console.log(values);

        const {data} = await Axios.post('bridge/leads/s3_upload_file.php',values).catch(function (error) {
            if (error.response) console.log(error.response.data, error.response.status, error.response.headers);
            else if (error.request) console.log(error.request);
            else console.log('Error', error.message);
            console.log(error.config);
            var error_data = {"error" : error, "url" : error.request && error.request.url ? error.request.url : "none provided"};
            //email_axios_error(error_data);
        });

        console.log(data);

        return data;
    }
    
    const listDocuments = async (lead_id) => {

        const values = {"lead_id":lead_id};

        const {data} = await Axios.post('bridge/leads/s3_list_files.php',values).catch(function (error) {
            if (error.response) console.log(error.response.data, error.response.status, error.response.headers);
            else if (error.request) console.log(error.request);
            else console.log('Error', error.message);
            console.log(error.config);
            var error_data = {"error" : error, "url" : error.request && error.request.url ? error.request.url : "none provided"};
            //email_axios_error(error_data);
        });

        console.log(data);

        return data;
    }

    const getAnnouncements = async () => {

        var values = {'action':'get_announcements'};

        const {data} = await Axios.post('bridge/leads/announcements.php',values).catch(function (error) {
            if (error.response) console.log(error.response.data, error.response.status, error.response.headers);
            else if (error.request) console.log(error.request);
            else console.log('Error', error.message);
            console.log(error.config);
            var error_data = {"error" : error, "url" : error.request && error.request.url ? error.request.url : "none provided"};
            //email_axios_error(error_data);
        });

        return data.success && data.announcements ? data.announcements : {};
    }

    const announcementsModify = async (values) => {

        console.log(values);

        const {data} = await Axios.post('bridge/leads/announcements.php',values).catch(function (error) {
            if (error.response) console.log(error.response.data, error.response.status, error.response.headers);
            else if (error.request) console.log(error.request);
            else console.log('Error', error.message);
            console.log(error.config);
            var error_data = {"error" : error, "url" : error.request && error.request.url ? error.request.url : "none provided"};
            //email_axios_error(error_data);
        });

        console.log(data);

        return data.success && data.announcements ? data.announcements : {};
    }

    const getImageType = (title) => {
        var image = "note-icon.svg";
        switch (title) {
            case "Agent Note": image = "note-icon.svg"; break;
            case "Sent SMS": image = "send-icon.svg"; break;
            case "Sent Email": image = "envlope-icon.svg"; break;
            case "Phone Call": image = "phone-icon.svg"; break;
            default: image = "note-icon.svg"; break;
        }

        return image;
    }

    const validateVIN = (inputVIN) => {
      var vin = inputVIN.toLowerCase().trim();
    
      var patt = new RegExp("^[^Wioq]{17}$");
    
      if (!patt.test(vin)) {
        return false;
      }
    
      var weights = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
    
      var transliterations = [];
    
      transliterations["a"] = 1;
      transliterations["b"] = 2;
      transliterations["c"] = 3;
      transliterations["d"] = 4;
      transliterations["e"] = 5;
      transliterations["f"] = 6;
      transliterations["g"] = 7;
      transliterations["h"] = 8;
      transliterations["j"] = 1;
      transliterations["k"] = 2;
      transliterations["l"] = 3;
      transliterations["m"] = 4;
      transliterations["n"] = 5;
      transliterations["p"] = 7;
      transliterations["r"] = 9;
      transliterations["s"] = 2;
      transliterations["t"] = 3;
      transliterations["u"] = 4;
      transliterations["v"] = 5;
      transliterations["w"] = 6;
      transliterations["x"] = 7;
      transliterations["y"] = 8;
      transliterations["z"] = 9;
    
      var sum = 0;
      var i = 0;
    
      for (i = 0; i < vin.length; i++) {
        // loop through characters of VIN
        // add transliterations * weight of their positions to get the sum
        if (isNaN(vin[i])) {
          sum += transliterations[vin[i]] * weights[i];
        } else {
          sum += parseInt(vin[i]) * weights[i];
        }
      }
    
      var checkdigit = sum % 11;
    
      if (checkdigit == 10) {
        checkdigit = "x";
      }
    
      return checkdigit == vin[8];
    }

    const vehicleListSearch = async (values) => {

        const response = await Axios.post('bridge/vehicle/search.php',values);
        console.log(response.data ? response.data : response);

        return response.data ? response.data : response;

    }

    const getVehicleYears = async () => {
        const data = await vehicleListSearch({ 'subject': 'year' });

        setDefaultYears(data);
    }
    
    const numberFormatter = (value, currency = false) => {
        var num = value ? value.toString().replace(/[^0-9\.]+/g,"") : 0;
        //var thousands = num >= 1000;
    
        //if(thousands) num = Math.round(num / 100) / 10;
        
        var sign = num >= 0 ? "" : "-";
        var str = num.toString().replace("$", ""), parts = false, output = [], i = 1, formatted = null;
        if(str.indexOf(".") > 0) {
            parts = str.split(".");
            str = parts[0];
        }
        str = str.split("").reverse();
        for(var j = 0, len = str.length; j < len; j++) {
            if(str[j] != ",") {
                output.push(str[j]);
                if(i%3 == 0 && j < (len - 1)) {
                    output.push(",");
                }
                i++;
            }
        }
        formatted = output.reverse().join("");
        return((currency ? "$" : "") + sign + formatted + ((parts) ? "." + parts[1].substr(0, 2) : ""));
        // + (thousands ? "k" : "")
    }

    const socketRef = useRef();

    const sendUpdateMessage = (type="") => {
        console.log("sending socket update to other agents");
        
        socketRef.current.emit('message', {
            id: user.username,
            refreshLeads: 'true',
            type: type
        });
    }

    useEffect(() => {
        if(!socketRef.current && user && user.username) {
            console.log("setting socket ref");
            socketRef.current = io("https://cardropcrm.com:9000", {
                transports: ['websocket']
            });
        }

    }, [user]);

    useEffect(() => {

        function handleMessage(message){
            console.log("socket received message",message);
            getNotifications();

            getLeads(false,searchRef.current == "");
        }

        function connectFunction() {
            console.log("connected",socketRef.current);

            socketRef.current.emit('message', {
                id: user.username,
                getChatHistory: 'true'
            });    
            
        }

        if(socketRef.current) {

            console.log("setting socket events");

            socketRef.current.on('error', function() {
                console.log("Sorry, there seems to be an issue with the connection!");
            });
        
            socketRef.current.on('connect_error', function(err) {
                console.log("connect failed ",err);
            });
        
            socketRef.current.on('connect', connectFunction);

            //socketRef.current.on('connection', connectFunction);

            socketRef.current.on('message', handleMessage);
    
            return () => {
              socketRef.current.off('connect', connectFunction);
            };
        }
    }, [user]);

    const priceFormatter = (value, currency = false) => {
        var num = value ? value.toString().replace(/[^0-9\.]+/g,"") : 0;
        
        var sign = num >= 0 ? "" : "-";
        var str = num.toString().replace("$", ""), parts = false, output = [], i = 1, formatted = null;
        if(str.indexOf(".") > 0) {
            parts = str.split(".");
            str = parts[0];
        }
        str = str.split("").reverse();
        for(var j = 0, len = str.length; j < len; j++) {
            if(str[j] != ",") {
                output.push(str[j]);
                if(i%3 == 0 && j < (len - 1)) {
                    output.push(",");
                }
                i++;
            }
        }
        formatted = output.reverse().join("");
        return((currency ? "$" : "") + sign + formatted + ((parts) ? "." + parts[1].substr(0, 2) : ""));
        // + (thousands ? "k" : "")
    }

    const initialLoad = async () => {
        
        getLeadFields();
        const data = await getLeads();
        getAllLeads();
        getEmailScripts();
        getTextScripts();
        getAgents();
        getLeaderboard();
        getNotifications();
        getVehicleYears();

        setIsInitialLoad(false);
        
    }

    useEffect(() => {
        if(user && user.username && user.username != 'publicuser') {
            initialLoad();
        }
        // console.log(user);
    },[user]);

    return (
        <>
            <LeadsContext.Provider value={{getLeads,isInitialLoad,leadsLoading,singlePagination,setsinglePagination,activeTab,setActiveTab,searchText,setSearchText,searchExists,leadsFetching,filteredLeads,filteredSMLeads,leadData,archivedLeadData,filteredArchivedLeadData,baseURL,leadSearch,selectLead,activeLeadID, emailScripts, textScripts, leadFields, agentData, sendSms, sendPlainTextEmail, assignAgent, updateTask, completeNextTask, updateLeadData, updateLeadDataMultiple, addNote, deleteNote, updateNote, addEmailScript, deleteEmailScript, addLead, leaderboard, archiveLead, getImageType, decodeVIN, validateVIN,selectedId,setSelectedId,vehicleListSearch,numberFormatter,notifications,activeLeadAction,setActiveLeadAction,uploadDocument,listDocuments,allLeads,getAnnouncements,announcementsModify,getLeadData,migrateWebLead,queryLeadID,setQueryLeadID,copySniperMonkeyLead,getEmailScriptsHtml,priceFormatter,defaultYears}}>
                {children}
            </LeadsContext.Provider>
        </>
    );
}

export default LeadsContextProvider